import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=0f4f2ddd&scoped=true&"
import script from "./Messaging.vue?vue&type=script&lang=js&"
export * from "./Messaging.vue?vue&type=script&lang=js&"
import style0 from "./Messaging.vue?vue&type=style&index=0&id=0f4f2ddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f2ddd",
  null
  
)

export default component.exports